import { useState, useCallback, useRef } from 'react';

export interface OrderedSelection {
  filterKey: string;
  value: string;
}

export function useOrderedFilterSelections() {
  const [orderedSelections, setOrderedSelections] = useState<OrderedSelection[]>([]);
  const selectionsRef = useRef(orderedSelections);
  selectionsRef.current = orderedSelections;

  const updateFilter = useCallback((filterKey: string, newValues: string[], prevValues: string[]) => {
    const added = newValues.filter((v) => !prevValues.includes(v));
    const removed = prevValues.filter((v) => !newValues.includes(v));

    setOrderedSelections((prev) => {
      let next = prev.filter(
        (s) => !(s.filterKey === filterKey && removed.includes(s.value))
      );
      for (const val of added) {
        next = [...next, { filterKey, value: val }];
      }
      return next;
    });
  }, []);

  const clearFilter = useCallback((filterKey: string) => {
    setOrderedSelections((prev) => prev.filter((s) => s.filterKey !== filterKey));
  }, []);

  const clearAll = useCallback(() => {
    setOrderedSelections([]);
  }, []);

  return { orderedSelections, updateFilter, clearFilter, clearAll };
}
